module.exports = __webpack_public_path__ + "img/collection-diamondJewelry@2x.1cdaa54.webp";